export const IfElse = (props: {
  if: boolean;
  else?: React.ReactNode;
  children: React.ReactNode;
}) => {
  if (props.if) return props.children;
  else return props.else || null;
};
